import { Box, List, ListItemButton, ListItemIcon, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import WeSawLogo from '../assets/images/Logo-WeSaw.png'
import WeDryLogo from '../assets/images/Logo-WeSaw.png'
import WePlaneLogo from '../assets/images/Logo-WePlane.png'
import WeScheduleLogo from '../assets/images/Logo-WeSchedule.png'
import WeTrackLogo from '../assets/images/Logo-WeTrack.png'

import WeDryImage from '../assets/images/WeDry.png'
import WePlaneImage from '../assets/images/WePlane.png'
import WeSawImage from '../assets/images/WeSaw.png'
import WeScheduleImage from '../assets/images/WeSchedule.png'
import WeTrackImage from '../assets/images/WeTrack.png'
import '../assets/style/style.css'

const products = [
  { id: 1, licenseName: 'WeSaw', imageUrl: WeSawImage, miniImageUrl: WeSawLogo, link: '/WeSaw' },
  { id: 2, licenseName: 'WePlane', imageUrl: WePlaneImage, miniImageUrl: WePlaneLogo, link: '/WePlane' },
  { id: 3, licenseName: 'WeTrack', imageUrl: WeTrackImage, miniImageUrl: WeTrackLogo, link: '/WeTrack' },
  { id: 4, licenseName: 'WeSchedule', imageUrl: WeScheduleImage, miniImageUrl: WeScheduleLogo, link: '/WeSchedule' },
  { id: 5, licenseName: 'WeDry', imageUrl: WeDryImage, miniImageUrl: WeDryLogo, link: '/WeDry' },
]

interface ProductsContainerProps {
  siteLicenses?: string[]
  onClose?: () => void
  isOpen?: boolean
}

const ProductsContainer = ({ siteLicenses, onClose, isOpen = true }: ProductsContainerProps) => {
  const { t, i18n } = useTranslation()
  const [myProducts, setMyProducts] = useState<typeof products>([])
  const [otherProducts, setOtherProducts] = useState<typeof products>([])
  const location = useLocation()
  const currentPath = location.pathname

  const supportedLanguages = ['en', 'fr']
  const rawLang = i18n.language.slice(0, 2)
  const languageToUse = supportedLanguages.includes(rawLang) ? rawLang : 'en'
    
  const listItemTextStyles = {
    margin: '0',
    padding: '8px 16px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    lineHeight: '1.5',
    fontWeight: '400',
    letterSpacing: '0.00938em',
  }



  useEffect(() => {
    if (siteLicenses) {
      const myProducts = products.filter((product) => siteLicenses.includes(product.licenseName))
      const otherProducts = products.filter((product) => !siteLicenses.includes(product.licenseName))
      setMyProducts(myProducts)
      setOtherProducts(otherProducts)
    }
  }, [siteLicenses])

  const renderProducts = (productList: typeof products, isMyProducts: boolean) => (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '0px',
        paddingBottom: '0px',
        width: '100%',
      }}
    >
      {productList.map((product) => {
        const isSelected = currentPath === product.link
        const handleClick = () => {
          onClose?.()
          if (!isMyProducts) {
            const url = `https://www.pmpsolutions.ca/${languageToUse}/products/pmp-${product.licenseName}`
            window.open(url, '_blank')
          }
        }

        return (
          <List sx={{ width: '100%' }} key={product.id}>
            <Tooltip title={!isOpen ? product.licenseName : ''} placement="right">
              <ListItemButton
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: 0,
                  padding: isOpen ? '10px' : '6px',
                  minWidth: 0,
                }}
                selected={isSelected}
                component={isMyProducts ? Link : 'div'}
                to={isMyProducts ? product.link : undefined}
                onClick={handleClick}
              >
                <ListItemIcon
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    ...(isOpen ? { width: '45%' } : { minWidth: 0, width: '36px' }),
                  }}
                >
                  <img
                    src={isOpen ? product.imageUrl : product.miniImageUrl}
                    alt={product.licenseName}
                    style={isOpen ? {} : { width: '32px', height: '32px', objectFit: 'contain' }}
                  />
                </ListItemIcon>
              </ListItemButton>
            </Tooltip>
          </List>
        )
      })}
    </List>
  )

  return (
    <Box
    id="product-section">
      {isOpen && <Typography variant="subtitle2" sx={listItemTextStyles}>{t('products.myProducts')}</Typography>}
      {renderProducts(myProducts, true)}
      {isOpen && otherProducts.length > 0 && (
        <>
          <Typography variant="subtitle2" sx={listItemTextStyles}>{t('products.otherProducts')}</Typography>
          {renderProducts(otherProducts, false)}
        </>
      )}
    </Box>
  )
}

export default ProductsContainer
